'category'.datatype({source: 'WC'})
'categoryName'.field({key: true})
